import { PreviewTimeOffRequestBalanceResponse } from '../types/dto/preview-time-off-balance.dto';
import { TimeOffBalancePreview } from '../types/time-off-balance-preview';

export const mapTimeOffBalancePreviewFromDTO = (
  response: PreviewTimeOffRequestBalanceResponse
): TimeOffBalancePreview => ({
  availableAfterBooking: response.availableAfterBooking,
  isSufficient: response.isSufficient,
});
